module.exports = __webpack_public_path__ + "static/media/D-edit.a74191e2.svg";